import { SET_ROUTE } from 'actions/types';

const initialState = {};

export default (state = initialState, action: { type: string; payload: object }) => {
  if (action.type === SET_ROUTE) {
    return {
      ...state,
      ...action.payload,
    };
  }

  return state;
};
